
if(typeof FN == 'undefined') FN = {};

FN.mayTheFork = {
  contentType: false,
  lightsaberImg: false,
  loadLightsaberImage: function(){
    /* Load Lightsaber Image
    *  We load it via JavaScript because we want to show it only when it has fully loaded. So the GIF animation starts at the right time.
    */
    FN.mayTheFork.lightsaberImg = new Image();
    FN.mayTheFork.lightsaberImg.src = $('#lightsaber').attr('data-image-src');
    FN.mayTheFork.lightsaberImg.onload = function(){
      $('#lightsaber').append(FN.mayTheFork.lightsaberImg);
      setTimeout(function(){
        $('#lightsaber img').css({'opacity': '1.0'});
      }, 100);
    }
  },
  showStickerForm: function(){
    $('.button--stickersignup-revealer').hide();
    $('.newsletter-form').show();
    $('.store-content__stickers__address').show().focus();
  },
  toggleContentType: function(){
    FN.mayTheFork.contentType = (FN.helpers.getURLParameterByName('type') === 'stickers') ? 'stickers' : 'default';
    if(FN.mayTheFork.contentType === 'stickers' && $('.store-content__stickers').length == 1){
      $('.store-content__stickers').show();
    }else{
      $('.store-content__signup').show();
    }
  },
  sendTicket: function(data, options){
    var requestData = { 'message': options.dataPostalAddress,
                        'subject': 'May the Fork Be with You - Stickers',
                        'email': options.dataEmail,
                        'name': 'Sticker Participant',
                        'category': 'Sales Issue'
                      };
    var requestURL = FN.config.urls.ticket;
    FN.remoteRequest.sendRequest(requestURL, requestData, {'responseContainer':false});
  }
};



FN.popupConfig.addPopupConfig({
  'id': 'fn-popup_incentive_maythefork',
  'type': 'modal',
  'active': true,
  'pagePaths': ['.*'],
  'display': {
    'event': 'onClick',
    'selector': '.button--incentive_maythefork',
    'showOnlyOnce': false
  },
  'content': [
    { 'type': 'newsletter-signup',
      'text': '<h2 class="fn-popup__text--headline">Download the Wallpaper<span class="fn-popup__text--tag">Free</span></h2><p class="fn-popup__text--subline">Get a set of awesome wallpapers for your desktop!</p><span class="fn-popup__image"><img src="' + FN.config.urls.base + 'assets/img/specialsites/may-the-fork/popup_maythefork.png" width="194" /></span>',
      'action-button': 'Get the Wallpaper',
      'signup-medium': 'tower-blog',
      'signup-URI': 'fn-popup_incentive_maythefork',
      'tags': [
        { 'id': 'tower_newsletter', 'label': "Yes, send me the wallpaper and sign me up for the Tower newsletter. It's free, it's sent infrequently, you can unsubscribe any time - and it's loved by over <b>100,000 developers & designers</b>!", 'default': false, 'hidden': false, 'collectConsent': true},
        { 'id': 'incentive_mayfork', 'label': "", 'default': true, 'hidden': true, 'collectConsent': false}
      ],
      'consent': [
        { 'id': 'legal', 'required': true, 'text': 'I have read and accept the <a href="' + FN.siteURL('tower', 'legal/privacy-policy') + '" target="_blank">Privacy Policy</a>. <br/>I understand that I can unsubscribe at any time.'}
      ]
    }
  ]
});




$(document).ready(function(){
  /*********** Configure Analytics Event Tracking */
  var micrositeAnalyticsEvents = [
    /* Page Links */
    { 'config': { 'selector': '.button--store.analytics--click', 'waitBeforeDefault': true },
      'event':  { 'eventCategory': 'page-interaction', 'eventAction': 'landing-page', 'eventLabelSuffix': 'may-the-fork/stuff-store' }
    },
    { 'config': { 'selector': '.social-button--about.analytics--click', 'waitBeforeDefault': true },
      'event':  { 'eventCategory': 'page-interaction', 'eventAction': 'landing-page', 'eventLabelSuffix': 'may-the-fork/tower-website' }
    },
    /* Social Share */
    { 'config': { 'selector': '.social-button--twitter.analytics--click' },
      'event':  { 'eventCategory': 'social', 'eventAction': 'share', 'eventLabelSuffix': 'may-the-fork/twitter' }
    },
    { 'config': { 'selector': '.social-button--facebook.analytics--click' },
      'event':  { 'eventCategory': 'social', 'eventAction': 'share', 'eventLabelSuffix': 'may-the-fork/facebook' }
    },
    { 'config': { 'selector': '.social-button--linkedin.analytics--click' },
      'event':  { 'eventCategory': 'social', 'eventAction': 'share', 'eventLabelSuffix': 'may-the-fork/linkedin' }
    }
  ];
  FN.analytics.addConfiguredEvents(micrositeAnalyticsEvents);


  /*********** prefill "source[OS]" value in newsletter forms */
  if($('input[name="signup[OS]"]').length > 0){
    $('input[name="signup[OS]"]').val(FN.helpers.platform());
  }

  /*********** load lightsaber image */
  FN.mayTheFork.loadLightsaberImage();

  /*********** Display either Wallpaper+Poster info -OR- sticker giveaway */
  FN.mayTheFork.toggleContentType();

  /************ Show Info Area */
  setTimeout(function(){
    $('.store-content__wrapper').css({'right': '0px'});
    $('.store-content__wrapper .social-button').addClass('social-button--animated');
  }, 2500);

  $('.button--stickersignup-revealer').on('click', function(event){
    FN.mayTheFork.showStickerForm();
    event.preventDefault();
  });
});
